import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21 14.5a1.51 1.51 0 0 0-1.41 1H18c-.64 0-1-.65-1.55-1.72A5.8 5.8 0 0 0 15.27 12a5.8 5.8 0 0 0 1.18-1.78C17 9.15 17.36 8.5 18 8.5h1.59a1.5 1.5 0 1 0 0-1H18c-1.31 0-1.91 1.21-2.45 2.28S14.64 11.5 14 11.5h-.55a2.5 2.5 0 0 0-4.9 0H4.41a1.5 1.5 0 1 0 0 1h4.14a2.5 2.5 0 0 0 4.9 0H14c.64 0 1 .65 1.55 1.72S16.69 16.5 18 16.5h1.59a1.5 1.5 0 1 0 1.41-2m-10-1a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5" }, null, -1)
  ]))]))
}
export default { render: render }